import types from './types';

/* eslint-disable import/prefer-default-export */
export function requestLogout() {
  return {
    type: types.LOGOUT_REQUEST,
  };
}



// WEBPACK FOOTER //
// ./src/state/ducks/auth/actions.js